import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import ServiceBoxRegular from '../../Shared/ServiceBox/ServiceBoxRegular/ServiceBoxRegular';
import coreProductPlus from './Images/coreProductPlus.svg';
import coreProductMinus from './Images/coreProductMinus.svg';
import Config from '../../../Config';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import {ActionType, ActionTabType, ActionGroupType} from './CoreProductEnum';
import {
  getActionsByTypes,
  getCustomerCoreProducts,
  setTabs,
  setSelectedTab,
  setShowAllItems,
  mappingEpiData,
  pushCoreProductActions,
} from './CoreProductActionsSlice';
import {isMobile} from 'react-device-detect';

const CoreProductActionsMain = (props) => {
  const dispatch = useDispatch();
  let customerPrivteOrBusiness;
  useEffect(() => {
    if (props.isActionsLoaded && props.isCustomerInitLoaded) {
      let coreProductsTypes = props.coreProductsTypes;
      let customerType = props.customerType;
      if (customerType?.isPrivate) {
        customerPrivteOrBusiness = 'private';
      }
      if (customerType?.isBusiness) {
        customerPrivteOrBusiness = 'business';
      }

      var actionsTitle = props.iContent.selfCareActionsTitle?.value;
      var commonTroubleShootingTitle = props.iContent.commonTroubleShootingTitle?.value;

      var coreProductActions = mappingEpiData(props.iContent.coreProductActions?.expandedValue);
      var coreProductCommonTroubleShootingArea = mappingEpiData(props.iContent.coreProductCommonTroubleShootingArea?.expandedValue);

      var isHaveOrganization = props.organizationState?.organizationCodeList?.value?.length > 0;
      if (isHaveOrganization) {
        let coreProductGroup;
        var isHaveOrganizationCoreProductData = props.organizationState?.coreProductGroup?.expandedValue != null;
        if (isHaveOrganizationCoreProductData) {
          coreProductGroup = props.organizationState?.coreProductGroup?.expandedValue[0];
          if (coreProductGroup?.selfCareActionsTitle?.value != null) {
            actionsTitle = coreProductGroup.selfCareActionsTitle?.value;
          }
          if (coreProductGroup?.commonTroubleShootingTitle?.value != null) {
            commonTroubleShootingTitle = coreProductGroup.commonTroubleShootingTitle?.value;
          }

          var isHaveActions =
            coreProductGroup.coreProductActions?.expandedValue != null && coreProductGroup.coreProductActions?.expandedValue?.length > 0;

          if (isHaveActions) {
            coreProductActions = mappingEpiData(coreProductGroup.coreProductActions?.expandedValue);
          }
          var isHaveCommonTroubleShootingArea =
            coreProductGroup.coreProductCommonTroubleShootingArea?.expandedValue != null &&
            coreProductGroup.coreProductCommonTroubleShootingArea?.expandedValue?.length > 0;
          if (isHaveCommonTroubleShootingArea) {
            coreProductCommonTroubleShootingArea = mappingEpiData(coreProductGroup.coreProductCommonTroubleShootingArea?.expandedValue);
          }
        }
      }
      dispatch(
        pushCoreProductActions({
          coreProductsTypes: [...coreProductsTypes, customerPrivteOrBusiness],
          coreProductActions: coreProductActions,
          coreProductCommonTroubleShootingArea: coreProductCommonTroubleShootingArea,
          customerType:props.customerType,
        })
      );

      const tabs = [
        {
          name: actionsTitle,
          type: ActionTabType.ACTIONS,
        },
        {
          name: commonTroubleShootingTitle,
          type: ActionTabType.ACTIONSCOMMONTROUBLESHOOTING,
        },
      ];
      dispatch(setTabs(tabs));
    }
  }, [props.isActionsLoaded, props.isCustomerInitLoaded]);

  const onSelectTab = (tab) => {
    if (tab.type != props.selectedTab.type) {
      dispatch(setSelectedTab(tab));
      dispatch(setShowAllItems(false));
    }
  };

  const getActionsView = (actions) => {
    if (props.selectedTab.type == ActionTabType.ACTIONS) {
      actions = props.actions;
    } else if (props.selectedTab.type == ActionTabType.ACTIONSCOMMONTROUBLESHOOTING) {
      actions = props.actionsCommonTroubleShooting;
    }

    let view = [];
    let row = [];

    const maxTotalItem = 12;
    const maxItemInRow = 6;

    for (var index = 0; index < actions.length; index++) {
      let isNeedMarginLeft =
        (index + 1 == actions.length && props.showAllItems == false) || (index + 1 == maxItemInRow && props.showAllItems == true); //(isLastItem)

      //push action to row
      row.push(
        <div className='actionCol'>
          <ServiceBoxRegular
            isNeedMarginLeft={isNeedMarginLeft}
            key={index}
            badgeText={'חדש'}
            isHaveBadge={actions[index].isNew}
            backgroundImageUrl={Config.epiBaseUrl + actions[index]?.iconUrl}
            actionUrl={actions[index]?.actionUrl}
            actionName={actions[index]?.actionName}
            context={EpiContext}
            callback={(actionUrl) => {
              prepareUrl(actionUrl, EpiContext);
            }}></ServiceBoxRegular>
        </div>
      );
      //if row == maxItemInRow add new row
      if (!isMobile) {
        if (row.length >= maxItemInRow) {
          view.push(<div className='actionRow'>{row}</div>);
          row = [];
        }
        //if actions ended add row to view
        else if (index + 1 == actions.length) {
          view.push(<div className='actionRow'>{row}</div>);
        }
        //add more items button for last item
        if (maxTotalItem == index + 1 && props.showAllItems == false) {
          row.push(
            <div
              className='actionCol'
              onClick={() => {
                dispatch(setShowAllItems(!props.showAllItems));
              }}>
                { props?.actions?.length>12 && 
              <ServiceBoxRegular
                isNeedMarginLeft={true}
                key={index}
                backgroundImage={coreProductPlus}
                actionName={'פעולות נוספות'}
                backgroundColorProperty={'#f4eefc'}
                callback={() => {}}></ServiceBoxRegular>
                }
            </div>
          );
          view.push(<div className='actionRow'>{row}</div>);
          break;
        }
        if (props.showAllItems == true) {
          if (view.length > 1 && index + 1 >= actions.length) {
            var lastRowInView = view[view.length - 1];
            var actions = lastRowInView.props.children.length;
            if (actions > maxItemInRow - 1) {
              view.push(
                <div className='actionRow'>
                  <div
                    className='actionCol'
                    onClick={() => {
                      dispatch(setShowAllItems(false));
                    }}>
                    <ServiceBoxRegular
                      key={index}
                      backgroundImage={coreProductMinus}
                      actionName={'הסתר פעולות'}
                      backgroundColorProperty={'#f4eefc'}
                      callback={() => {}}></ServiceBoxRegular>
                  </div>
                </div>
              );
            } else {
              view[view.length - 1].props.children.push(
                <div
                  className='actionCol'
                  onClick={() => {
                    dispatch(setShowAllItems(false));
                  }}>
                  <ServiceBoxRegular
                    key={index}
                    backgroundImage={coreProductMinus}
                    actionName={'הסתר פעולות'}
                    backgroundColorProperty={'#f4eefc'}
                    callback={() => {}}></ServiceBoxRegular>
                </div>
              );
            }
          }
        }
      } else {
        if (index + 1 == actions.length) {
          view.push(<div className={actions.length >= maxItemInRow ? 'actionRow actionRow-mobile' : 'actionRow'}>{row}</div>);
        }
      }
      //add close more actions button for last item
    }

    return <>{view}</>;
  };

  return (
    <>
      {props.isActionsReady && (
        <div className='coreProductActionsComponent'>
          <div className='headerContainer'>
            <div className='title'>איך נוכל לעזור?</div>
            <div className='tabContainer'>
              {props.tabs &&
                props.tabs.length > 0 &&
                props.tabs.map((tab, index) => {
                  return (
                    <>
                      <div
                        key={index}
                        className={props.selectedTab.type == tab.type ? 'tabTitle selectedTab' : 'tabTitle'}
                        onClick={() => onSelectTab(tab)}>
                        {tab.name}
                      </div>
                      {index == 0 ? <div className='split'></div> : <></>}
                    </>
                  );
                })}
            </div>
          </div>
          <div style={{overflowX: 'auto'}}>{getActionsView()}</div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    coreProductsTypes: state.coreProductActions?.coreProductsTypes,
    isActionsLoaded: state.coreProductActions?.isActionsLoaded,
    isActionsReady: state.coreProductActions?.isActionsReady,
    actions: state.coreProductActions?.actions,
    actionsCommonTroubleShooting: state.coreProductActions?.actionsCommonTroubleShooting,
    selectedTab: state.coreProductActions?.selectedTab,
    showAllItems: state.coreProductActions?.showAllItems,
    tabs: state.coreProductActions?.tabs,
    isCustomerInitLoaded: state.coreProductActions?.isCustomerInitLoaded,
    organizationState: state.welcomeBlock?.organizationState,
    customerType: state.welcomeBlock?.customerType,
  };
};

export default connect(mapStateToProps)(CoreProductActionsMain);
